module.exports = __webpack_public_path__ + "static/img/win_button.afdeca7a.png";